import React, {useEffect, useRef, useState} from 'react';
import {IDatasetToggleTableConfigProps} from "./common/api/interfaces/interfaces";
import DatasetToggleCard from "./DatasetToggleCard";
import './DatasetToggleTable.scss';
import {Toast, ToastSeverityType} from "primereact/toast";
import {ProgressSpinner} from "primereact/progressspinner";
import {DatasetDataApi} from "api/DatasetDataApi"
import {DatasetDataInfoResponse} from "api/apiModels";
import {DatasetDefaultConfig} from "models/dataset-models";
import NonExistantDatasetsPrinting from "../../basic/non-existant-datasets-printing/NonExistantDatasetsPrinting";

const dataApi = new DatasetDataApi()

const DatasetToggleTable = (props: IDatasetToggleTableConfigProps) => {

    const [loading, setLoading] = useState<boolean>(true)

    const [datasetData, setDatasetData] = useState<Array<DatasetDataInfoResponse>>([]);
    const [nonExistent, setNonExistent] = useState<Array<string>>([])

    const myToast = useRef<Toast>(null);
    const order = props.datasets.map(obj => obj.identifier);

    useEffect(() => {
        dataApi.getRecentData(order,1, {strict: false})
            .then((res) => {
                if (res.data) {
                    if (res.data.length > 0) {
                        setDatasetData(keepQueue(res.data))
                    }
                }
                setLoading(false);
            })
            .catch((err) => {
                console.error(err)
                setLoading(false);
            })
    }, [props.datasets])

    useEffect(() => {
        findUnexistingDatasets()
    }, [datasetData])

    const keepQueue = (data: Array<any>): Array<any> => {
        return order.map(obj => {
            return data.find(e => e.identifier === obj)
        })
    }

    const findUnexistingDatasets = () => {
        let unexistringDatasets:Array<string> = [];
        props.datasets.forEach((conf: DatasetDefaultConfig) => {
            let obj = datasetData.find(ob => {
                if (ob && ob.identifier === conf.identifier) {
                    return ob
                }
            });

            if (!obj) {
                unexistringDatasets.push(conf.identifier)
            }
        })

        setNonExistent(unexistringDatasets)
    }

    const showToast = (severityValue: ToastSeverityType, summaryValue: string, detailValue: string) => {
        myToast.current!.show({severity: severityValue, summary: summaryValue, detail: detailValue});
    }


    if (loading) {
        return <div style={{width: "100%", height: "100%", overflow: "hidden"}}>
            <ProgressSpinner className={"middle-class"}/>
        </div>
    }

    if (!props.datasets || props.datasets.length === 0) {
        return <div className={"no-data"}>No datasets provided..</div>
    }

    if (props.datasets && props.datasets.length > 0 && datasetData.length === 0 && !loading) {
        return <div className={"no-data-wrapper"}>
            {nonExistent.length > 0 && <NonExistantDatasetsPrinting datasetsArray={nonExistent}/>}
        </div>
    }

    if(datasetData.length>0 && !loading) {
        return <div className={"main-window"}>
            <Toast ref={myToast} position={'bottom-right'}></Toast>
            {
                props.datasets.map((conf: DatasetDefaultConfig, index: number) => {

                    let object = datasetData.find(ob => {
                        if (ob && ob.identifier === conf.identifier) {
                            return ob
                        }
                    });


                    if (object) {
                        let buttonValue: boolean = false;
                        if (object.data) {
                            if (object.data.length > 0) {
                                let ats = object.data[0].value ? object.data[0].value : 0;
                                if (ats) {
                                    if (ats !== 0) {
                                        buttonValue = true;
                                    }
                                }
                            }
                        }
                        return <div className={"card-class"} key={index}>
                            <DatasetToggleCard result={object}
                                               config={conf}
                                               value={buttonValue}
                                               truncateTo={props.truncateTo}
                                               showToast={(severity, summary, detail) => showToast(severity, summary, detail)}
                            />
                        </div>
                    }
                    return <div key={index}></div>
                })
            }
            {nonExistent.length > 0 && <NonExistantDatasetsPrinting datasetsArray={nonExistent}/>}
        </div>
    }
};

export default DatasetToggleTable;